import axios from "axios";

if (!process.env.REACT_APP_API_BASE_URL) {
  console.warn(
    "REACT_APP_API_BASE_URL is not set. Defaulting to http://localhost:3001/api",
  );
}




const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:3001/api",
  headers: {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache, no-store, must-revalidate",
    "Pragma": "no-cache",
    "Expires": "0",
  },
});

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor to handle token refresh
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    const excludeUrls = ["/login", "/register", "/refresh"];
    const shouldExclude = excludeUrls.some(url => 
      originalRequest.url?.includes(url)
    );
    
    // If error is 401 and we haven't already tried to refresh
    if (error.response?.status === 401 && !originalRequest._retry && !shouldExclude) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("refresh_token");
        if (!refreshToken) {
          throw new Error("No refresh token");
        }

        // Call refresh endpoint
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL || "http://localhost:3001/api"}/refresh`,
          { refresh_token: refreshToken },
          { headers: { "Content-Type": "application/json" } },
        );

        const newAccessToken = response.data.access_token;
        localStorage.setItem("access_token", newAccessToken);

        // Retry the original request with new token
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return api(originalRequest);
      } catch (refreshError) {
        // Refresh failed, clear tokens and redirect to appropriate login page
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");

        // Check if current path is admin-related
        const currentPath = window.location.pathname;
        const isAdminRoute = currentPath.startsWith("/admin");
        
        // Redirect to appropriate login page
        if (isAdminRoute && currentPath !== "/admin/login") {
          window.location.href = "/admin/login";
        } else if (!isAdminRoute && currentPath !== "/login") {
          window.location.href = "/login";
        }

        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  },
);

export default api;
